export const AppPermissions = {
  // Main permissions
  PortalAccess: 'BBR.ReportsPortalAccess@BBR',
  // Reports Permissions
  PlayerReports: 'BBR.GetPlayerReports@BBR',
  SessionReports: 'BBR.GetSessionReports@BBR',
  UmpireReports: 'BBR.GetUmpireReport@BBR',
  PracticeReports: 'BBR.GetPracticeReports@BBR',
  // Default Layout Editing Permissions
  DefaultLayoutEdit: 'BBR.EditReportLayout@BBR',
  // Admin Permission
  Admin: 'BB.Admin@BB',
};
